// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"8523f1f1","161":"06c49ffc","239":"e7a2ff17","241":"3e0a79a6","355":"b88f6552","396":"26071eee","455":"54fb1674","673":"b1e7f193","715":"94cdb16f","722":"c4662f89","857":"44e4468d","882":"f71eb206","889":"5863551e","977":"a723575a"}[chunkId] + ".chunk.js";
};